import storeInfo from '../store'

export const getSelectedEstimates = (): string[] => {
  const { estimateSelection: { selectedEstimates } } = storeInfo.store.getState()
  return selectedEstimates || []
}

export const isEstimateSelected = (estimateId: string): boolean => {
  const selectedEstimates = getSelectedEstimates()
  return selectedEstimates.includes(estimateId)
}

export const getAssignMultipleModalOpen = (): boolean => {
  const { estimateSelection: { assignMultipleModalOpen } } = storeInfo.store.getState()
  return assignMultipleModalOpen || false
}

export const getAssignMultipleLoading = (): boolean => {
  const { estimateSelection: { assignMultipleLoading } } = storeInfo.store.getState()
  return assignMultipleLoading || false
}